import React from 'react'

export default function InformacionPersonalBasica() {
  return (
    <div>
      InformacionPersonalBasica
    </div>
  )
}
